import { TreeNode } from '~/eds/src/types/TreeNode';
import { VariationData } from '~/redux/api/methods/clauseLibrary';
import { sortStrings } from '~/utils/sortStrings';

import { Position } from './types';

const sortByPosition = (a: Position, b: Position): number => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  const order = {
    Preferred: -1,
    Fallback: 0,
    'Walk away': 1,
  };
  return order[a] - order[b];
};

export const sortVariationsByPositionAndName = (
  a: VariationData | TreeNode,
  b: VariationData | TreeNode,
): number => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  const aPosition: Position =
    (a as VariationData).position ?? (a as TreeNode).status?.label;
  const bPosition: Position =
    (b as VariationData).position ?? (b as TreeNode).status?.label;
  if (aPosition !== bPosition) {
    // compare positions
    return sortByPosition(aPosition, bPosition);
  } else {
    // same position, sort alphabetically by name
    return sortStrings(a.name, b.name);
  }
};
